/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import notify from 'devextreme/ui/notify'
import { alert, confirm } from 'devextreme/ui/dialog'
import Form from 'devextreme-react/form'
import DevextremeTab from 'components/inheritComponent/devextremeTab'
import { formatDateString, formatUploadFileData } from 'plugin/helper'
import XLSX from 'xlsx'

import { FileUploader } from 'devextreme-react'
import {
  gender,
  agama,
  maritalStatus,
  banks,
  eduBackground,
  statusPajak,
} from 'dataSource/lookup'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import httpRequest from 'plugin/httprequest'

class UploadPesertaParticipant extends Component {
  constructor(props) {
    super(props)

    this.fileUploderRef = React.createRef()

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.state = {
      popupVisible: false,
      uploadedData: [],
      DataDocument: {},
      // selectedTabIndex: 0,
    }

    this.dataGridSesuaiRef = React.createRef()
    this.dataGridTakSesuaiRef = React.createRef()

    this.formItem = {
      useHeader: true,
    }

    this.successData = []
    this.errorData = []

    this.jenisKelamin = []
    this.statusKepegawaian = []
    this.agama = []
    this.jenisKantor = []
    this.unit = []
    this.statusKaryawan = []
    this.grade = []
    this.months = []
    this.jabatan = []
    this.married = []
    this.tax = []
    this.country = []
    this.province = []
    this.city = []
    this.kecamatan = []
    this.kelurahan = []
    this.banks = []
    this.products = []

    this.prevTabIndex = 0

    this.checkboxItem = [
      {
        dataField: 'useHeader',
        label: {
          alignment: 'left',
          text: 'Use Header',
        },
        editorType: 'dxCheckBox',
      },
    ]
    this.columns = [
      {
        dataField: 'nik',
        caption: 'NIK *',
      },
      {
        dataField: 'namaLengkap',
        caption: 'Nama Lengkap *',
      },
      {
        dataField: 'jenisKelamin',
        caption: 'Jenis Kelamin *',
        lookup: {
          dataSource: gender(),
          valueExpr: 'id', // contains the same values as the "statusId" field provides
          displayExpr: 'value', // provides display values
        },
      },
      {
        dataField: 'tempatLahir',
        caption: 'Tempat Lahir *',
      },
      {
        dataField: 'tanggalLahir',
        caption: 'Tanggal Lahir *',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'agama',
        caption: 'Agama *',
        lookup: {
          dataSource: agama(),
          valueExpr: 'id', // contains the same values as the "statusId" field provides
          displayExpr: 'value', // provides display values
        },
      },
      {
        dataField: 'tanggalMasaKerja',
        caption: 'Tanggal Diakui Masa Kerja *',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'pendidikan',
        caption: 'Pendidikan *',
        lookup: {
          dataSource: eduBackground(),
          valueExpr: 'id', // contains the same values as the "statusId" field provides
          displayExpr: 'value',
        },
      },
      {
        dataField: 'statusPerkawinan',
        caption: 'Status Perkawinan *',
        lookup: {
          dataSource: maritalStatus(),
          valueExpr: 'id', // contains the same values as the "statusId" field provides
          displayExpr: 'value', // provides display values'
          searchEnabled: true,
          deferRendering: false,
        },
      },
      {
        dataField: 'statusPajak',
        caption: 'Status Pajak *',
        lookup: {
          dataSource: statusPajak(this.props.store),
          valueExpr: 'statusName', // contains the same values as the "statusId" field provides
          displayExpr: 'statusName', // provides display values'
          searchEnabled: true,
          deferRendering: false,
        },
      },
      {
        dataField: 'nomorNpwp',
        caption: 'No NPWP *',
      },
      {
        dataField: 'nomorKtp',
        caption: 'No KTP *',
      },
      {
        dataField: 'nomorKk',
        caption: 'No KK *',
      },
      {
        dataField: 'alamat11',
        caption: 'Alamat Peserta *',
      },
      {
        dataField: 'alamat16',
        caption: 'Kode Pos Peserta *',
      },
      {
        dataField: 'alamat21',
        caption: 'Alamat Domisili *',
      },
      {
        dataField: 'alamat26',
        caption: 'Kode Pos Domisili *',
      },
      {
        dataField: 'teleponRumahTinggal',
        caption: 'Telepon Rumah Tinggal *',
      },
      {
        dataField: 'nomorHp1',
        caption: 'Nomor Hp 1 *',
      },
      {
        dataField: 'email1',
        caption: 'Email 1 *',
      },
      {
        dataField: 'nomorBpjsTk',
        caption: 'No BPJS TK *',
      },
      {
        dataField: 'nomorRekening',
        caption: 'No Rekening *',
      },
      {
        dataField: 'namaRekening',
        caption: 'Nama Rekening *',
        // lookup: {
        //     dataSource: banks(this.props.store),
        //     valueExpr: 'id', // contains the same values as the "statusId" field provides
        //     displayExpr: 'bankName', // provides display values'
        //     searchEnabled: true,
        //     deferRendering: false,
        // },
      },
      {
        dataField: 'kodeBankRekening',
        caption: 'Kode Bank Rekening *',
        lookup: {
          dataSource: banks(this.props.store),
          valueExpr: 'id', // contains the same values as the "statusId" field provides
          displayExpr: 'bankCode', // provides display values'
          searchEnabled: true,
          deferRendering: false,
        },
      },
      {
        dataField: 'kodeMis',
        caption: 'Kode MIS *',
      },
      {
        dataField: 'noBpjsKesehatan',
        caption: 'Nomor BPJS Kesehatan *',
      },
      {
        dataField: 'phdpUpp',
        caption: 'PHDP (Upp) *',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'takeHomePay',
        caption: 'Take Home Pay *',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'kewarganegaraan',
        caption: 'Kewarganegaraan *',
        lookup: {
          dataSource: [
            { id: 1, value: 'WNI' },
            { id: 2, value: 'WNA' },
          ],
          valueExpr: 'id',
          displayExpr: 'value',
        },
      },
      {
        dataField: 'produkPensiun',
        caption: 'Produk Pensiun *',
        // lookup: {
        //     dataSource: productDefault(this.props.store),
        //     valueExpr: 'id',
        //     displayExpr: 'productCode',
        //     searchEnabled: true,
        //     deferRendering: false,
        // },
      },
      {
        dataField: 'iuranNormalPesertaPpip1',
        caption: 'Iuran Normal Peserta PPIP *',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranNormalPkPpip1',
        caption: 'Iuran Normal PK PPIP *',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranSukarelaPpip1',
        caption: 'Iuran Sukarela PPIP',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'namaIstriSuami',
        caption: 'Nama Istri/Suami',
      },
      {
        dataField: 'noKtpIstriSuami',
        caption: 'No KTP Suami/Istri',
      },
      {
        dataField: 'tanggalLahirPasangan',
        caption: 'Tanggal Lahir Pasangan',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tempatLahirPasangan',
        caption: 'Tempat Lahir Pasangan',
      },
      {
        dataField: 'namaAnak1',
        caption: 'Nama Anak 1',
      },
      {
        dataField: 'tanggalLahirAnak1',
        caption: 'Tanggal Lahir Anak 1',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tempatLahirAnak1',
        caption: 'Tempat Lahir Anak 1',
      },
      {
        dataField: 'namaAnak2',
        caption: 'Nama Anak 2',
      },
      {
        dataField: 'tanggalLahirAnak2',
        caption: 'Tanggal Lahir Anak 2',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tempatLahirAnak2',
        caption: 'Tempat Lahir Anak 2',
      },
      {
        dataField: 'namaAnak3',
        caption: 'Nama Anak 3',
      },
      {
        dataField: 'tanggalLahirAnak3',
        caption: 'Tanggal Lahir Anak 3',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tempatLahirAnak3',
        caption: 'Tempat Lahir Anak 3',
      },
    ]

    this.TabDataSource = [
      {
        id: 0,
        text: 'Data Sesuai',
      },
      {
        id: 1,
        text: 'Data Tidak Sesuai',
      },
    ]

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let result = await confirm(
              'Apakah Anda yakin menyimpan data ini?',
              'Konfirmasi'
            )
            if (result) {
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]
  }

  retrieveDataSuccess = () => {
    return this.successData
  }

  retrieveDataFailed = () => {
    return this.errorData
  }

  onUploadStarted = async (e) => {
    let fieldNames = e.component._options._optionManager._options.name

    for (let i = 0; i < e.value.length; i++) {
      let file = e.value[i]
      let fileName = file.name
      let fileType = fileName.split('.').pop().toLowerCase()

      const reader = new FileReader()
      let jumlahData = 0

      reader.onload = async (e) => {
        let dataArrayBuffer = new Uint8Array(e.target.result)
        let data

        // Proses file berdasarkan tipe
        if (fileType === 'xls' || fileType === 'xlsx') {
          let workbook = XLSX.read(dataArrayBuffer, { type: 'array' })
          let sheet = workbook.Sheets[workbook.SheetNames[0]]
          let dataJSON = XLSX.utils.sheet_to_json(sheet, { defval: null })
          data = dataJSON.map((value) =>
            Object.values(value).map((val) => (val === undefined ? null : val))
          )
        } else if (fileType === 'csv') {
          let dataString = this.ab2str(dataArrayBuffer)
          data = dataString
            .split(/\r\n|\n/)
            .map((line) => line.split(',').map((val) => val.trim()))
        } else {
          notify({ message: 'Invalid file type!', width: 'AUTO' }, 'error', 600)
          return
        }

        let successData = []
        let errorData = []

        data.forEach((row, index) => {
          let isValid = row
            .slice(0, 32)
            .every((value) => value !== null && value !== '')
          if (isValid) {
            successData.push(this.mapToDataFormat(row))
          } else {
            errorData.push(this.mapToDataFormat(row))
          }
        })
        jumlahData = data.length
        if (errorData.length > 0) {
          await alert(
            'Ada beberapa data yang tidak sesuai. Silahkan cek tab Data Tidak Sesuai',
            'Info'
          )
          // this.errorData = errorData;
          this.editDataGrid(errorData, 'error')
        }

        // this.successData = successData;
        this.editDataGrid(successData, 'success')
      }

      reader.readAsArrayBuffer(file)

      const fr = new FileReader()
      let DataDocument = { ...this.state.DataDocument }

      let formattedFileData
      fr.onload = (efr) => {
        formattedFileData = formatUploadFileData(efr.target.result)

        DataDocument[`${fieldNames}Name`] = file.name
        DataDocument[`${fieldNames}File`] = formattedFileData.base64data
        DataDocument[`${fieldNames}FileContentType`] = formattedFileData.mime

        this.setState({
          DataDocument: {
            file: formattedFileData.base64data,
            fileContentType: formattedFileData.mime,
            filename: file.name,
            statusId: 1,
            jumlahPeserta: jumlahData,
            uploadDate: new Date(),
          },
        })
      }

      fr.readAsDataURL(file)
    }
  }

  ab2str = (buf) => {
    return String.fromCharCode.apply(null, new Uint8Array(buf))
  }

  mapToDataFormat = (row) => {
    return {
      nik: row[0],
      namaLengkap: row[1],
      jenisKelamin: row[2],
      tempatLahir: row[3],
      tanggalLahir: row[4] ? formatDateString(row[4].toString()) : null,
      agama: row[5],
      tanggalMasaKerja: row[6] ? formatDateString(row[6].toString()) : null,
      pendidikan: row[7],
      statusPerkawinan: row[8],
      statusPajak: row[9],
      nomorNpwp: row[10],
      nomorKtp: row[11],
      nomorKk: row[12],
      alamat11: row[13],
      alamat16: row[14],
      alamat21: row[15],
      alamat26: row[16],
      teleponRumahTinggal: row[17],
      nomorHp1: row[18],
      email1: row[19],
      nomorBpjsTk: row[20],
      nomorRekening: row[21],
      namaRekening: row[22],
      kodeBankRekening: row[23],
      kodeMis: row[24],
      noBpjsKesehatan: row[25],
      phdpUpp: row[26],
      takeHomePay: row[27],
      kewarganegaraan: row[28],
      produkPensiun: row[29],
      iuranNormalPesertaPpip1: row[30],
      iuranNormalPkPpip1: row[31],
      iuranSukarelaPpip1: row[32],
      namaIstriSuami: row[33],
      noKtpIstriSuami: row[34],
      tanggalLahirPasangan: row[35]
        ? formatDateString(row[35].toString())
        : null,
      tempatLahirPasangan: row[36],
      namaAnak1: row[37],
      tanggalLahirAnak1: row[38] ? formatDateString(row[38].toString()) : null,
      tempatLahirAnak1: row[39],
      namaAnak2: row[40],
      tanggalLahirAnak2: row[41] ? formatDateString(row[41].toString()) : null,
      tempatLahirAnak2: row[42],
      namaAnak3: row[43],
      tanggalLahirAnak3: row[44] ? formatDateString(row[44].toString()) : null,
      tempatLahirAnak3: row[45],
    }
  }

  editDataGrid = async (data, type) => {
    let dataGrid
    if (type === 'success') {
      dataGrid = this.dataGridSesuaiRef
    } else {
      dataGrid = this.dataGridTakSesuaiRef
    }
    let editData = []
    await this.deleteDataGrid(dataGrid)
    for (let value of data) {
      try {
        editData.push({
          type: 'insert',
          data: value,
        })
      } catch (e) {
        console.log(e)
      }
    }
    dataGrid.current.push(editData)
    this.dataGridSesuaiRef.current.forceRefresh()
  }

  deleteDataGrid = async (dataGrid) => {
    let data = dataGrid.current.getDataSource()
    let deleteData = []
    for (let value of data) {
      deleteData.push({
        type: 'remove',
        key: value.nik,
      })
    }
    dataGrid.current.push(deleteData)
  }

  submitData = async () => {
    let dataGrid = this.dataGridSesuaiRef
    let data = dataGrid.current.getDataSource()

    let updatedData = data.map((item) => ({
      ...item,
      participantId: this.props.store.getState().sessionUser
        ? this.props.store.getState().sessionUser.participantId
        : 0,
    }))

    let dataSubmit = {
      dtlDTOList: updatedData,
      ...this.state.DataDocument,
    }

    try {
      let postAPI = 'participant-peserta-uploads/bulk'
      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        postAPI,
        'POST',
        {
          values: dataSubmit,
        }
      )

      let text = `Data berhasil dikonfirmasi!`
      let type = 'success'

      notify(
        {
          message: text,
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        type,
        600
      )

      this.hide()
      this.props.forceRefresh()
    } catch (e) {
      console.log(e)
      notify(
        {
          message: e,
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        600
      )
    }
  }

  show = () => {
    this.setState({
      popupVisible: true,
    })
    this.forceRefreshSuccess()
    this.forceRefreshFailed()
  }

  hide = () => {
    this.setState({
      popupVisible: false,
    })
    this.successData = []
    this.errorData = []
    this.prevTabIndex = 0
  }

  onTabSelectionChanged = (args) => {
    document
      .getElementById(`tabuploadindex-${args.value}`)
      .classList.remove('d-none')

    document
      .getElementById(`tabuploadindex-${this.prevTabIndex}`)
      .classList.add('d-none')

    this.prevTabIndex = args.value
    if (args.value === 1) {
      this.forceRefreshFailed()
    }
  }

  forceRefreshSuccess = () => {
    this.dataGridSesuaiRef.current.forceRefresh(true)
  }

  forceRefreshFailed = () => {
    this.dataGridTakSesuaiRef.current.forceRefresh(true)
  }

  onValueChanged = (e) => {
    this.setState({
      useHeader: e.value,
    })
  }

  renderElement1 = () => {
    return (
      <DevExpressDataGrid
        ref={this.dataGridSesuaiRef}
        loadAPI=""
        insertAPI=""
        updateAPI=""
        deleteAPI=""
        backendserver={process.env.REACT_APP_BACKEND_CORE}
        useArraySource={true}
        ArraySourceData={this.retrieveDataSuccess}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={false}
        exportExcel={false}
        exportFileName={'Data Sukses'}
        allowExportSelectedData={false}
        showBorders={true}
        paging={false}
        defaultPageSize={10}
        //bagian konfigurasi popup saat insert dan edit record
        popupTitle={'Data Sukses'}
        popupWidth={500} //masukan dalam ukuran pixel
        popupHeight={300} //masukkan dalam ukuran pixel
        popupFormLabelLocation="left" //accepted value = top, left, right
        popupFormMinColWidth={300} // minimum lebar kolom
        popupFormColCount={3} //jumlah kolom pada form
        //akhir bagian konfigurasi popup

        ColumnChooser={false} // set false agar kolom tidak dapat di pindah pindah
        ColumnFixing={true} // set false agar kolom tidak dapat di freeze
        FilterRow={false} // set false untuk mematikan fitur filter
        ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
        // SummaryConfiguration={this.summary}
        // onToolbarPreparing = {this.onToolbarPreparing}

        height={'calc(70vh - 250px)'}
        keyField={'nik'}
        //contoh konfigurasi kolom
        //this.columns = [{
        //    dataField: 'kolom1',
        //    caption: 'Ini Kolom 1'
        //}, {
        //    dataField: 'kolom2',
        //    caption: 'Ini Kolom 2'
        //}]
        // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

        store={this.props.store} // jangan di edit edit
      />
    )
  }

  renderElement2 = () => {
    return (
      <DevExpressDataGrid
        ref={this.dataGridTakSesuaiRef}
        loadAPI=""
        insertAPI=""
        updateAPI=""
        deleteAPI=""
        backendserver={process.env.REACT_APP_BACKEND_CORE}
        useArraySource={true}
        ArraySourceData={this.retrieveDataFailed}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={false}
        exportExcel={false}
        exportFileName={'Data Sukses'}
        allowExportSelectedData={false}
        showBorders={true}
        paging={false}
        defaultPageSize={10}
        //bagian konfigurasi popup saat insert dan edit record
        popupTitle={'Data Sukses'}
        popupWidth={500} //masukan dalam ukuran pixel
        popupHeight={300} //masukkan dalam ukuran pixel
        popupFormLabelLocation="left" //accepted value = top, left, right
        popupFormMinColWidth={300} // minimum lebar kolom
        popupFormColCount={3} //jumlah kolom pada form
        //akhir bagian konfigurasi popup

        ColumnChooser={false} // set false agar kolom tidak dapat di pindah pindah
        ColumnFixing={true} // set false agar kolom tidak dapat di freeze
        FilterRow={false} // set false untuk mematikan fitur filter
        ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
        // SummaryConfiguration={this.summary}
        // onToolbarPreparing = {this.onToolbarPreparing}

        height={'calc(70vh - 250px)'}
        keyField={'nik'}
        //contoh konfigurasi kolom
        //this.columns = [{
        //    dataField: 'kolom1',
        //    caption: 'Ini Kolom 1'
        //}, {
        //    dataField: 'kolom2',
        //    caption: 'Ini Kolom 2'
        //}]
        // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

        store={this.props.store} // jangan di edit edit
      />
    )
  }

  render() {
    let elemTab1 = this.state.popupVisible && this.renderElement1()
    let elemTab2 = this.state.popupVisible && this.renderElement2()
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={false}
        showTitle={true}
        title={'Upload Peserta'}
        width={'90vw'}
        height={'70vh'}
        toolbarItems={this.PopupToolbarItem}
      >
        <div className="d-flex flex-row">
          <div style={{ width: '350px' }}>
            <FileUploader
              accept={'.txt,.xls,.xlsx,.csv'}
              uploadMode={'useForm'}
              onValueChanged={this.onUploadStarted.bind(this)}
              labelText="Upload Peserta File Disini"
              showFileList={false}
              name={'uploadPesertaParticipant'}
              value={this.state.uploadedData}
              ref={this.fileUploderRef}
            />
          </div>
          <div className="d-flex flex-row align-items-center mb-2">
            <Form
              ref={this.formRef}
              id={'formUseHeader'}
              colCount={1}
              formData={this.formItem}
              items={this.checkboxItem}
              scrollingEnabled={false}
              labelLocation="left"
            />
          </div>
        </div>
        <DevextremeTab
          dataSource={this.TabDataSource}
          onOptionChanged={this.onTabSelectionChanged}
        />
        <div id="tabuploadindex-0" className={' mt-2 col-md-12 text-center'}>
          {elemTab1}
        </div>
        <div
          id="tabuploadindex-1"
          className={' d-none mt-2 col-md-12 text-center'}
        >
          {elemTab2}
        </div>
      </Popup>
    )
  }
}

export default UploadPesertaParticipant
